import React, { useEffect, useState } from 'react';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import TableComponent from '../../../components/DataTable/TableComponent';

const AttributionTable = () => {

    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const columns = [
        { name: "#ID", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (index + 1) },
        {
            name: "Ad Medium", selector: (row) => row?.channel_name, cell: (row) => (
                <p className="mb-0.5 font-semibold text-sm text-primary">{row?.adMediumString || "N/A"}</p>
            )
        }, {
            name: "Unique Clicks", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.uniqueClicks}</p>
            )
        }, {
            name: "Clicks", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.clicks}</p>
            )
        }, {
            name: "Installs", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.installs}</p>
            )
        }, {
            name: "Cost", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">₹ {row?.cost || 0}</p>
            )
        }, {
            name: "Download Clicks", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.downLoadClicks}</p>
            )
        }, {
            name: "Re-Engage", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.reEngage}</p>
            )
        }, {
            name: "Re-Installs", center: "true", selector: (row) => row?.title, cell: (row) => (
                <p className="mb-0">{row?.installs}</p>
            )
        }
    ];

    async function getTableData() {
        let resp = await getApi(urlApi.getAttributionTableData);
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data,
                totalCount: resp?.data?.length
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        getTableData();
    }, [])

    return (
        <div className='p-2 bg-[#fff] rounded-lg h-full mb-4'>
            <div className='flex items-center gap-3 justify-between mb-2'>
                <div>
                    <p className='mb-0 text-md font-bold text-[var(--grey)]'>Attribution Table</p>
                    <p className='mb-0 text-xs text-gray-400'>Overview of your Ad Mediums.</p>
                </div>
            </div>
            <TableComponent
                isHeader={true}
                columns={columns}
                data={tableData?.data}
                totalRows={tableData?.totalCount}
                isPagination={false}
                paginationPerPage={10}
                handlePageChange={(e) => { }}
                handlePerRowsChange={(newPerPage, page) => { }} />
        </div>
    )
}

export default AttributionTable